import React, {useEffect, useState} from 'react';
import {Button, SearchBar as AntSearchBar} from 'antd-mobile';
import {ScanningOutline} from 'antd-mobile-icons';
import {useBarCodeScanner} from 'components/BarCodeScanner';
import {isTrackingNumber} from "../../../utils/BarCodeUtil";
import {t} from "../../../i18n";
import {useNetwork} from "../../../hooks/useNetwork";
import {showNetworkErrorModal} from "../../../components/NetworkErrorModal";
import {playScanSound} from "../../../utils/scanUtils";

interface DspSearchBarProps {
    onSearch: (value: string) => void;
}

const DspSearchBar: React.FC<DspSearchBarProps> = ({onSearch}) => {
    const [searchValue, setSearchValue] = useState('');
    const {isVisible, setIsVisible, scanResult} = useBarCodeScanner();
    const { isOnline } = useNetwork();

    useEffect(() => {
        setIsVisible(false);
        return () => {
            setIsVisible(true);
        };
    }, []);

    const handleSearch = (val: string) => {
        setSearchValue(val);
        onSearch(val);
    };

    const handleScan = () => {
        if (isOnline) {
            setIsVisible(!isVisible);
            return;
        }
        showNetworkErrorModal();
    };

    useEffect(() => {
        if (scanResult) {
            if (isTrackingNumber(scanResult)){
                playScanSound();
                handleSearch(scanResult);
            }
        }
    }, [scanResult]);

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center bg-white shadow-sm border-1 py-0">
                <div className="flex-1">
                    <AntSearchBar
                        placeholder={t('pages.dsp.operationalDataParticulars.searchPlaceholder')}
                        value={searchValue}
                        onChange={handleSearch}
                        style={{'--background': '#ffffff'}}
                    />
                </div>
                <div className="flex justify-center items-center">
                    <Button
                        onClick={handleScan}
                        fill="none"
                        size={"large"}
                    >
                        <ScanningOutline/>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DspSearchBar;